<template>
  <div id="login">
    <header>
   <div style="display: flex;padding-top: 16px;padding-left: 63px;">
    <img
            src="../assets/images/logo.png"
            class="logo"
            style="width: 4%;"
            @click="$router.push({ path: '/' })"
          />
          <span
            style="
              color: #d7000f;
              font-family: Douyin Sans;
              font-size: 18px;
              font-style: normal;
              font-weight: 700;
              line-height: 20px; /* 83.333% */
            "
          >
            环境产业互联网平台
          </span>
   </div>
  </header>
    <el-row class="login-info" :style="styles">
      <el-col :span="24" style="margin-bottom:20px;font-size:20px;">
        <b>用户注册</b>
      </el-col>
      <el-col :span="24">
        <!-- <el-input class="login-input" clearable maxlength="11" placeholder="请输入真实姓名" v-model="loginName"
          size="small"></el-input> -->
        <el-input class="login-input" clearable maxlength="11" placeholder="请输入真实姓名" v-model="userName"
          size="small"></el-input>
      </el-col>
      <el-col :span="24">
        <el-input class="login-input" clearable placeholder="请输入密码" show-password v-model="password"
          size="small"></el-input>
      </el-col>
      <el-col :span="24">
        <el-input class="login-input" clearable placeholder="再次输入密码" show-password v-model="affirmPassword"
          size="small"></el-input>
      </el-col>
      <el-col :span="24">
        <el-input class="login-input" clearable placeholder="请输入手机号" v-model="phonenumber" size="small"></el-input>
      </el-col>
      <el-col :span="24">
        <el-input class="login-input " placeholder="请输入短信验证码" size="small" v-model="smsCode" style="cursor:pointer">
          <div :disabled="smscodeDisabled" slot="append" v-if="setCode" size="small" style="font-size:14px;cursor:pointer"
            @click="getYzm">{{ setCode }}</div>
        </el-input>
      </el-col>
      <el-col :span="24">
        <el-input class="login-input norequired" clearable placeholder="请输入企业统一社会信用代码" size="small"
          v-model="companyCode"></el-input>
      </el-col>
      <el-col :span="24">
        <el-input class="login-input norequired" clearable placeholder="企业名称" size="small"
          v-model="companyName"></el-input>
      </el-col>
      <el-col :span="24" style="font-size:12px;margin-bottom:10px">
        <el-checkbox v-model="checked"></el-checkbox>阅读并接受
        <span @click="toFileInfo('ROLE_MAIN')" class="link">《平台总则》</span>、
        <span @click="toFileInfo('ROLE_SECRET')" class="link">《隐私权政策》</span>及
        <span @click="toFileInfo('ROLE_LAW')" class="link">《法律声明》</span>
        <!-- <span @click="toFileInfo('ROLE_INCORRUPT')" class="link">《廉政举报》</span> -->
        <!-- <span @click="toFileInfo('ROLE_ENCOURAGE')" class="link">《激励规则》</span> -->
      </el-col>
      <el-col :span="24">
        <el-button style="width:90%;" type="primary" :disabled="!checked" @click="regDone" size="small">注册</el-button>
      </el-col>
      <el-col :span="24" class="reg-text">
        <router-link :to="{ path: '/login' }" style="font-size:12px;">登录</router-link>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import count from "@/api/home";

export default {
  name: "Login",
  data() {
    return {
      smscodeDisabled: false,
      setCode: "获取验证码",
      smsCode: "",
      address: "",
      userName: "",
      password: "",
      companyName: "",
      companyCode: "",
      loginName: "",
      phonenumber: "",
      affirmPassword: "",
      checked: false,
      count: 60,
      show: true,
      timer: "",
    };
  },
  computed: {
    styles() {
      return {
        width: this.$store.state.app.device == 'desktop' ? '400px' : `${document.body.clientWidth - 10}px`,
        top: this.$store.state.app.device == 'desktop' ? '8%' : '5%',
        left: this.$store.state.app.device == 'desktop' ? '65%' : '5px',
      }
    }
  },
  methods: {
    // 获取短信验证码
    getYzm() {
      if (this.phonenumber === "") {
        return this.$message.error("请输入手机号");
      }
      if (!/^1[3456789]\d{9}$/.test(this.phonenumber)) {
        return this.$message.error("请输入正确的手机号");
      }
      this.validateBtn();
      let data = { mobile: this.phonenumber };
      count.getSmsCode(data).then((res) => {
        if (res.code == 0) {
          this.$message.success("验证码已发送 请注意查收");
        } else {
          this.$mesage.error(res.msg);
        }
      });
    },
    validateBtn() {
      //倒计时
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.smscodeDisabled = false;
          this.setCode = "发送验证码";
        } else {
          this.smscodeDisabled = true
          this.setCode = time + "秒后重试";
          time--;
        }
      }, 1000);
    },
    // 查看规则
    toFileInfo(type) {
      let routerJump = this.$router.resolve({
        path: "/file",
        query: { type: type },
      });
      console.log(routerJump);
      window.open(routerJump.href, "_blank");
    },
    // 注册
    regDone() {
      if (this.userName === "") {
        return this.$message.error("请输入真实姓名");
      }
      if (this.password === "") {
        return this.$message.error("请输入密码");
      }
      if (this.affirmPassword === "") {
        return this.$message.error("请再次输入密码");
      }
      if (this.affirmPassword !== this.password) {
        return this.$message.error("两次密码不一致，请重新输入密码");
      }
      if (this.phonenumber === "") {
        return this.$message.error("请输入手机号");
      }
      if (!/^1[3456789]\d{9}$/.test(this.phonenumber)) {
        return this.$message.error("请输入正确的手机号");
      }
      if (this.smsCode === "") {
        return this.$message.error("请输入手机验证码");
      }
      if (!/^([0-9A-HJ-NP-RT-UW-Y]){2}([0-9]){6}([0-9A-HJ-NP-RT-UW-Y]{10})$/.test(this.companyCode) && this.companyCode !== '') {
        return this.$message.error("请输入正确的企业代码");
      }
      const data = {
        userName: this.userName,
        password: this.password,
        affirmPassword: this.affirmPassword,
        phonenumber: this.phonenumber,
        companyName: this.companyName,
        companyCode: this.companyCode,
        smsCode: this.smsCode,
      };
      count.register(data).then((res) => {
        if (res.code === 0) {
          this.$message.success("注册成功！请登录！");
          setTimeout(() => {
            this.$router.push("/login");
          }, 3000);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
header{
  /* background: #fff; */
  height: 50px;
}
.code-btn {
  color: #ef8466;
  font-size: 12px !important;
  border: none;
  background-color: #f5f7fa;
  cursor: pointer;
}

.getCaptcha {
  display: block;
  width: 100px;
  height: 35px;
}

#login {
  text-align: center;
  font-size: 20px;
  width: 100%;
  height: 100vh;
  /* width: 100%;
  height: calc(100vh - 414px); */
  min-height: 600px;
  background: url("../assets/images/login_bg.png");
  /* background-position: center; */
  /* padding-top: 64px; */
}

.login-info {
  position: relative;
  /* left: 23%; */
  /* top: 10%; */
  /* width: 20%; */
  /* margin: 0 auto; */
  background-color: #fff;
  /* box-shadow: 10px 10px 10px #f2f2f2; */
  /* border-radius: 10px; */
  padding: 10px 0;
}

.foot-end {
  font-size: 12px;
  margin-top: 30px;
  padding-top: 10px;
  text-align: center;
  color: #939393;
  position: fixed;
  bottom: 0;
  margin: 0 auto;
  width: 100%;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.login-input {
  width: 90%;
  margin-bottom: 10px;
  position: relative;

  &:not(.norequired) {
    &::before {
      content: "*";
      color: red;
      position: absolute;
      left: -10px;
      top: 10px;
    }

  }
}

.link {
  text-decoration: underline;
  color: #409eff;
  cursor: pointer;
  font-size: 12px;
}

.cursor-pointer {
  cursor: pointer;
}

.reg-text {
  font-size: 12px !important;
  text-align: right;
  width: 95%;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue